import { render, staticRenderFns } from "./iconIconography.vue?vue&type=template&id=1866c5b6"
import script from "./iconIconography.vue?vue&type=script&lang=js"
export * from "./iconIconography.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports